module.exports = __webpack_public_path__ + "img/myriam-fuenzalida.8648cab7.jpg";